import MinionyWyjazd from "./MinionyWyjazd"

export default MinionyWyjazd
